import React from 'react'
import styles from './Footer.module.css'
import FooterLinks from './FooterLinks'
import type { FooterLinkItem } from './types'

const footerLinks: FooterLinkItem[] = [
    { href: 'https://cuolega.co.jp/profile/', text: '運営会社' },
    { href: 'https://cuolega.co.jp/privacy/', text: 'プライバシーポリシー' },
    { href: 'https://cuolega.co.jp/terms/', text: '利用規約' },
]

export default function Footer() {
    return (
        <div className={styles.footer} role='contentinfo'>
            <FooterLinks links={footerLinks} />
            <small>
                COPYRIGHT &copy; 2023 foods labo agent by cuolega ALL RIGHTS
                RESERVED.
            </small>
        </div>
    )
}
